import * as eaw from 'eastasianwidth'
import isValidDomain from 'is-valid-domain'

export const validateRegisterForm = async () => {
  let valid = true

  const lastNameKanjiCtrl = document.getElementById('register-last-name')
  const firstNameKanjiCtrl = document.getElementById('register-first-name')
  const lastNameKanaCtrl = document.getElementById('register-last-name2')
  const firstNameKanaCtrl = document.getElementById('register-first-name2')
  const cityCtrl = document.getElementById('register-city')
  const address1Ctrl = document.getElementById('register-adress')
  const address2Ctrl = document.getElementById('register-number')
  const phoneCtrl = document.getElementById('register-phone')
  const passwordInput = document.getElementById('register-password')
  const addressNameCtrl = document.getElementById('address-name')
  const viewAddressNameCtrl = document.getElementById('view_only_address_name')
  const postcodeCtrl = document.getElementById('register-post-code')
  const emailCtrl = document.getElementById('register-email')

  if (lastNameKanjiCtrl) {
    const lastNameKanji = lastNameKanjiCtrl.value
    lastNameKanjiCtrl.setCustomValidity('')

    if (eaw.length(lastNameKanji) > 14) {
      lastNameKanjiCtrl.setCustomValidity('全角7文字以内でご入力下さい。')
      valid = false
    }
  }

  if (firstNameKanjiCtrl) {
    const firstNameKanji = firstNameKanjiCtrl.value
    firstNameKanjiCtrl.setCustomValidity('')

    if (eaw.length(firstNameKanji) > 14) {
      firstNameKanjiCtrl.setCustomValidity('全角7文字以内でご入力下さい。')
      valid = false
    }
  }

  if (lastNameKanaCtrl) {
    const lastNameKana = lastNameKanaCtrl.value
    lastNameKanaCtrl.setCustomValidity('')

    if (eaw.length(lastNameKana) > 20) {
      lastNameKanaCtrl.setCustomValidity('全角10文字以内でご入力下さい。')
      valid = false
    }
  }

  if (firstNameKanaCtrl) {
    const firstNameKana = firstNameKanaCtrl.value
    firstNameKanaCtrl.setCustomValidity('')

    if (eaw.length(firstNameKana) > 20) {
      firstNameKanaCtrl.setCustomValidity('全角10文字以内でご入力下さい。')
      valid = false
    }
  }

  if (cityCtrl) {
    const city = cityCtrl.value
    cityCtrl.setCustomValidity('')

    if (eaw.length(city) > 80) {
      cityCtrl.setCustomValidity('全角40文字以内でご入力下さい。')
      valid = false
    }
  }

  if (address1Ctrl) {
    const address1 = address1Ctrl.value
    address1Ctrl.setCustomValidity('')

    if (eaw.length(address1) > 80) {
      address1Ctrl.setCustomValidity('全角40文字以内でご入力下さい。')
      valid = false
    }
  }

  if (address2Ctrl) {
    const address2 = address2Ctrl.value
    address2Ctrl.setCustomValidity('')

    if (eaw.length(address2) > 80) {
      address2Ctrl.setCustomValidity('全角40文字以内でご入力下さい。')
      valid = false
    }
  }

  if (phoneCtrl) {
    const phone = phoneCtrl.value
    phoneCtrl.setCustomValidity('')

    if (!phone.startsWith('0')) {
      phoneCtrl.setCustomValidity('電話番号は0から開始して下さい。')
      valid = false
    }

    if (phone.length < 10 || phone.length > 11) {
      phoneCtrl.setCustomValidity('電話番号の桁数を確認して下さい。')
      valid = false
    }
  }

  if (addressNameCtrl && viewAddressNameCtrl.innerHTML == '') {
    const addressName = addressNameCtrl.value
    addressNameCtrl.setCustomValidity('')

    if (addressName) {
      const addressNameCtrls = $('[data-address_name]')
      if (addressNameCtrls.length > 0) {
        const currentNames = addressNameCtrls
          .map(function () {
            return $(this).attr('data-address_name').toLowerCase()
          })
          .get()
          .filter(Boolean)

        if (currentNames.includes(addressNameCtrl.value.toLowerCase().trim())) {
          addressNameCtrl.setCustomValidity(
            '既存の登録名はご利用になれません。'
          )
          valid = false
        }
      }
    }
  }

  if (postcodeCtrl) {
    const postcodeValue = postcodeCtrl.value
    postcodeCtrl.setCustomValidity('')

    if (!postcodeValue || postcodeValue.length != 7) {
      postcodeCtrl.setCustomValidity('郵便番号は７桁で入力してください')
      valid = false
    }
  }

  if (passwordInput) {
    passwordInput.oninvalid = (event) => {
      event.target.setCustomValidity(
        'パスワードは英字と数字の両方を含む8文字以上でご入力ください。'
      )
    }

    passwordInput.oninput = (event) => {
      event.target.setCustomValidity('')
    }
  }

  if (emailCtrl) {
    // /account/login
    const email = emailCtrl.value
    emailCtrl.setCustomValidity('')
    $('.form-register .form__head .errors').remove()
    const at_count = email.match(/@/g).length
    if (at_count > 1 || at_count == 0) {
      valid = false
      emailCtrl.setCustomValidity('メールアドレスを正しく入力してください')
    } else if (
      !isValidDomain(email.split('@')[1], {
        subdomain: true,
        wildcard: false,
      })
    ) {
      valid = false
      emailCtrl.setCustomValidity('メールアドレスを正しく入力してください')
    } else {
      emailCtrl.setCustomValidity('')
    }
  }

  return valid
}
